export default __webpack_public_path__ + "static/media/mobileWef3Full.cf1b3fcd.png";